import { GiftCardCheckerFormActionType as ActionType } from '../types/action-type';
import { defaultGiftCardCheckerFormData } from '../types/form-data';
export const giftCardCheckerFormActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.SetFormData:
            return Object.assign(Object.assign({}, state), { formData: Object.assign(Object.assign({}, state.formData), action.formData) });
        case ActionType.SuccessfullyLoadedGiftCard:
            return Object.assign(Object.assign({}, state), { formData: defaultGiftCardCheckerFormData });
        case ActionType.FailedToLoadGiftCard:
            return Object.assign(Object.assign({}, state), { formData: Object.assign(Object.assign({}, state.formData), { captcha: undefined }) });
        case ActionType.SetFormSubmittingState:
            return Object.assign(Object.assign({}, state), { isSubmitting: action.isSubmitting });
        case ActionType.SetHelpText:
            return Object.assign(Object.assign({}, state), { helpTextsById: Object.assign(Object.assign({}, state.helpTextsById), { [action.helpText.id]: action.helpText }) });
        default:
            return state;
    }
};
